import React from 'react'

export const PopulateError = ({ errors }) => {
  return errors.map((error, i) => {
    return <li key={i}>{error}</li>
  })
}



// WEBPACK FOOTER //
// ./src/components/Common/PopulateError.js